module.exports = {"460106001":"中山街道","460106002":"滨海街道","460106003":"金贸街道","460106004":"大同街道","460106005":"海垦街道","460106006":"金宇街道","460106100":"城西镇","460106101":"龙桥镇","460106102":"新坡镇","460106103":"遵谭镇","460106104":"龙泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460106.json
// module id = 2313
// module chunks = 0